import { render, staticRenderFns } from "./versionEdit.vue?vue&type=template&id=77bf3a0c&scoped=true&"
import script from "./versionEdit.vue?vue&type=script&lang=js&"
export * from "./versionEdit.vue?vue&type=script&lang=js&"
import style0 from "./versionEdit.vue?vue&type=style&index=0&id=77bf3a0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bf3a0c",
  null
  
)

export default component.exports